import { BillingActionType } from '@src/types/billing.ts';
import { TOption } from '@src/types';

export const BillingActionData: TOption[] = [
  { value: BillingActionType.Canceled, label: 'Cancel' },
  { value: BillingActionType.Renew, label: 'Renew' },
];
